import http from "./../shared/axios";
import EncrDecrService from "../services/EncrDecrService.Service";
import { Otp_Gen } from "../shared/ServiceCommonEndpoints";
class OtpService {
  funcGenerateOtp(payload, reasonCode) {
    const otpInputData = {
      mobileNumber: payload.mobileNo,
      reasonCode: reasonCode,
      resendRequest: "true",
      orgId: "101",
      regenerationFlag: "true",
    };

    var encyMobile = EncrDecrService.set(payload.mobileNo)

    return http.post(Otp_Gen, otpInputData,
      {
        headers: {
          "IDENTIFIER_1": encyMobile,
          "IDENTIFIER_2": localStorage.getItem("visitorID"),
          "ENCRYPTED_ID": "1"
        }
      });
  }
}
// eslint-disable-next-line
export default new OtpService();
